import React from "react";
import { useNavigate } from "react-router-dom";

import Selo from "../comum/Selo";
import Tabela from "../comum/Tabela";
import { dataHora, num, pct, qtdTotal, qtdVendida, reais } from "../comum/formato";
import { rotaPromocao } from "../rotas";

const TIPO_COR = { promocao: "text-emerald-600 dark:text-emerald-400", de_por: "text-sky-600 dark:text-sky-400", nao_identificada: "text-red-500" };

export default function TabelaPromocoes({ promocoes, query }) {
  const navigate = useNavigate();
  const colunas = [
    { id: "nome", rotulo: "Promoção", valor: (p) => p.nome || "", render: (p) => (
      <div className="min-w-0">
        <p className="font-semibold">{p.nome}</p>
        <p className={`text-[11px] font-semibold ${TIPO_COR[p.tipo]}`}>{p.tipo_rotulo}{p.dias_semana?.length ? <span className="text-muted-foreground font-normal"> · {p.dias_semana.join(", ")}</span> : null}{p.horario ? <span className="text-muted-foreground font-normal"> · {p.horario}</span> : null}</p>
      </div>) },
    { id: "status", rotulo: "Status", valor: (p) => p.status, render: (p) => <Selo status={p.status} rotulo={p.status_rotulo} /> },
    { id: "unidades", rotulo: "Quantidade", alinhar: "direita", valor: qtdTotal, render: (p) => <b className="whitespace-nowrap">{qtdVendida(p)}</b> },
    { id: "pedidos", rotulo: "Pedidos", alinhar: "direita", valor: (p) => p.pedidos, render: (p) => p.pedidos },
    { id: "faturado", rotulo: "Faturado", alinhar: "direita", valor: (p) => p.faturado, render: (p) => reais(p.faturado) },
    { id: "desconto", rotulo: "Desconto", alinhar: "direita", valor: (p) => p.desconto, render: (p) => (
      <span className="text-amber-600 dark:text-amber-400">{p.cobertura_desconto_pct === 0 && qtdTotal(p) ? "—" : reais(p.desconto)}</span>) },
    { id: "lucro", rotulo: "Lucro (ficha)", alinhar: "direita", valor: (p) => p.lucro, render: (p) => (p.lucro == null ? <span className="text-muted-foreground text-xs">sem ficha</span> : (
      <span className={p.lucro < 0 ? "text-red-500" : "text-emerald-600 dark:text-emerald-400"}>{reais(p.lucro)}<span className="block text-[10px] text-muted-foreground">{pct(p.margem_pct)}</span></span>)) },
    { id: "retorno", rotulo: "Retorno", alinhar: "direita", valor: (p) => p.retorno, render: (p) => (p.retorno ? `${num(p.retorno)}x` : "—") },
    { id: "ultima", rotulo: "Última venda", alinhar: "direita", valor: (p) => p.ultima_venda || "", render: (p) => <span className="text-xs">{p.ultima_venda ? dataHora(p.ultima_venda) : "—"}</span> },
  ];
  return (
    <section className="rounded-xl border bg-card p-4 sm:p-5">
      <div className="flex items-baseline justify-between gap-2 mb-2">
        <h3 className="font-semibold">Promoções</h3>
        <span className="text-xs text-muted-foreground">Clique numa promoção pra ver o relatório dela</span>
      </div>
      <Tabela colunas={colunas} linhas={promocoes} chave={(p) => p.chave} e2e="tabela-promocoes"
        onClicar={(p) => navigate(`${rotaPromocao(p.chave)}${query}`)} vazio="Nenhuma promoção com esses filtros." />
    </section>
  );
}
